import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import {
  HttpClient
} from "@angular/common/http";
import {cloneDeep} from 'lodash';

@Component({
  selector: 'app-duel-player-details',
  templateUrl: './duel-player-details.component.html',
  styleUrls: ['./duel-player-details.component.scss']
})
export class DuelPlayerDetailsComponent implements OnInit {

  @Input() tournamentId: string = '';
  @Input() playerId: string = '';
  @Input() activeModalClose: Function;
  @Input() backToDuelModal: Function;
  @Input() playerPhoto;

  @Input() currentDuelNumber;
  private playerPersonalData;
  private tournamentName: string = '';
  private duelSeries = [];
  private duelSeriesFormatted = [];

  private _walkOverName = 'Walk Over';

  private playerData;
  private dataRequestUrl = (
    tournamentId,
    playerId,
    currentDuelId,
  ) => {
    return `/api/tournament/${tournamentId}/player/${playerId}/${currentDuelId}`;
  }

  constructor(private httpService: HttpClient) { }

  ngOnInit(): void {
    this.httpService.get(
      this.dataRequestUrl(
        this.tournamentId,
        this.playerId,
        this.currentDuelNumber
      )
    ).subscribe((data) => {
      this.setPlayerData(data);
    });
  }

  completeCloseHandler () : void {
    this.backToDuelModal();
    this.activeModalClose();
  }

  setPlayerData (playerData): void {
    this.playerData = playerData;
    this.duelSeries = playerData.duel_series;
    this.playerPersonalData = {
      birthDate: playerData.birthdate,
      fullName: playerData.full_name
    }
    this.tournamentName = playerData.tournament_name;
    this.setDuelSeriesFormatted(this.duelSeries);
  }

  getPlayerData () {
    return this.playerData;
  }

  getPlayerPersonalData() {
    return this.playerPersonalData;
  }

  getDuelNumber (duel) {
    return duel.number;
  }

  getWinnerScore(duel) {
    return Math.max(duel.player_one_score, duel.player_two_score);
  }

  getDefeatedScore(duel) {
    return Math.min(duel.player_one_score, duel.player_two_score);
  }

  validScore(score) {
    return typeof score === 'string' || typeof score === 'number'
  }

  getWinnerName(duel) {
    if (this.validScore(duel.player_one_score) && this.validScore(duel.player_two_score)) {
      return duel.player_one_score >= duel.player_two_score
        ? duel.player_one_full_name || (duel.walkover && this._walkOverName) || ''
        : duel.player_two_full_name || (duel.walkover && this._walkOverName) || '';
    }
    return null;
  }

  getDefeatedName(duel) {
    if (this.validScore(duel.player_one_score) && this.validScore(duel.player_two_score)) {
      return duel.player_one_score < duel.player_two_score
        ? duel.player_one_full_name || (duel.walkover && this._walkOverName) || ''
        : duel.player_two_full_name || (duel.walkover && this._walkOverName) || '';
    }
    return null;
  }

  getTournamentName() : string {
    return this.tournamentName
  }

  getPlayerPhoto() {
    return this.playerPhoto;
  }

  getDuelSeries() {
    return this.duelSeries;
  }

  noWalkOver(firstName, secondName) {
    return firstName !== this._walkOverName && secondName !== this._walkOverName;
  }

  setDuelSeriesFormatted(duelSeriesArr) {
    const clonedCopy = cloneDeep(duelSeriesArr);
    // console.debug('clone copy', clonedCopy);
    this.duelSeriesFormatted = [];
    clonedCopy.forEach((duel) => {
      const [winnerName, defeatedName] = [this.getWinnerName(duel), this.getDefeatedName(duel)];
      // console.debug('players names', winnerName, defeatedName);
      if (winnerName && defeatedName) {
        const noWalkOver = this.noWalkOver(winnerName, defeatedName);
        this.duelSeriesFormatted.push({
          number: duel.number,
          winnerName: winnerName,
          defeatedName: defeatedName,
          winnerScore: noWalkOver ? this.getWinnerScore(duel): '',
          defeatedScore: noWalkOver ? this.getDefeatedScore(duel): '',
          finished: duel.status === 'finished',
        });
      }
    });
    // console.debug('damned formatted data', this.duelSeriesFormatted);
  }

  getDuelSeriesFormatted() {
    return this.duelSeriesFormatted;
  }

  duelIsFinished(duel) {
    return duel.finished;
  }

  winnerStyle(duel) {
    return this.duelIsFinished(duel)
      ? 'scoreCell winnerScoreCell'
      : 'scoreCell defeatedCell';
  }

  getDisplayedColumns() {
    return [
      'number',
      'winnerName',
      'score',
      'defeatedName',
    ];
  }

}
